module.exports = require("./iu-Latn");